import React, {useEffect, useState} from "react";

import {DistrictMapLegendItem} from "../../../utils/dynamic_district_map_legend_values";
import {IRegionGeometry} from "./map/api/charts_regions_api";
import {IOsmDistrictPolygon} from "./map/types/osm_district_polygon";

export interface OpenStreetMapBrowserOnlyProps {
    center?: [number, number];
    zoom?: number;
    height?: string;
    className?: string;
    markers?: Array<{
        id: string | number;
        coords: [number, number];
        popup?: string;
        onClick?: () => void;
        icon?: {
            url: string;
            sizes: [number, number];
        };
    }>;
    markerClustering?: boolean;
    disableClusteringAtZoom?: number;
    scrollWheelZoom?: boolean;
    fitBounds?: boolean;
    maxZoom?: number;
    regionsMapSlug?: string;
    regionsMapParentId?: number;
    regionsMapChildType?: number;
    regionsMapRegionId?: number;
    districtValuesBySlug?: Record<string, number>;
    districtStatsCitySlug?: string;
    addedMetricLabel?: string;
    locale?: string;
    legendColors?: string[];
    legendItems?: DistrictMapLegendItem[];
    legendType?: "quantitative" | "pricing";
    districtMetricFormat?: "default" | "percent";
    legendSize?: "default" | "large" | "xlarge";
    fitBoundsZoomOffset?: number;
    panToOfferId?: string | number | null;
    focusOfferLeftInsetPx?: number;
    districtPolygonTooltip?: boolean;
    markersLoading?: boolean;
    districtDrillDownEnabled?: boolean;
    onDistrictPolygonClick?: (district: IOsmDistrictPolygon) => void;
    cityOutlineMetric?: boolean;
    regionGeometry?: IRegionGeometry | null;
}

const OpenStreetMapBrowserOnly = (props: OpenStreetMapBrowserOnlyProps) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return null;
    }

    const OpenStreetMap = require("./OpenStreetMap").default as React.ComponentType<OpenStreetMapBrowserOnlyProps>;

    return <OpenStreetMap {...props} />;
};

export default OpenStreetMapBrowserOnly;
